// src/sections/Stakeholders.jsx

import { motion } from "framer-motion";
import { stakeholders } from "../data/siteContent";
import SectionIntro from "../components/motion/SectionIntro";
import { cardReveal, staggerParent, viewportOnce } from "../utils/motion";

export default function Stakeholders() {
  return (
    <section className="section-block" id="partners">
      <div className="container-shell">
        <SectionIntro
          eyebrow={stakeholders.eyebrow}
          title={stakeholders.title}
          align="center"
        />

        <motion.div
          className="stakeholder-grid"
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {stakeholders.items.map((item, index) => (
            <motion.div
              key={item}
              className={`stakeholder-card ${item === stakeholders.featured ? "stakeholder-card--featured" : ""}`}
              variants={cardReveal}
            >
              {item === stakeholders.featured && <span className="stakeholder-card__badge">FEATURED</span>}
              {item}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
